import React from "react";

import "./independence-day-hero-card.css";

/* ------------------------------------------------------------------------
 * Independence Day overlays for the hero card.
 *
 * Confetti drifting over the card, plus a sheen on the Explore Now button —
 * the sheen is a ::after in the stylesheet, applied by the w4t-id-cta class
 * that HeroSection.jsx puts on the button.
 *
 * Two things were built here and later removed at the client's request: a
 * dated badge and a flag on a pole. The card now carries no wording and no
 * flag, only the drifting colour.
 *
 * Nothing here restyles the card. It is mounted inside .hero-section-wrapper,
 * which is already position: relative and overflow: hidden, and the card's
 * own gradient, radius and glow layers are untouched.
 *
 * Entirely decorative: aria-hidden, nothing focusable.
 * ---------------------------------------------------------------------- */

const CONFETTI = [
    { left: "8%", w: 6, h: 6, radius: "2px", colour: "#FF9933", dur: 9, delay: 0 },
    { left: "19%", w: 5, h: 8, radius: "0", colour: "#138808", dur: 11, delay: 1.4 },
    { left: "30%", w: 6, h: 6, radius: "50%", colour: "#FFFFFF", dur: 10, delay: 2.9, border: "1px solid rgba(31,31,31,.18)" },
    { left: "41%", w: 5, h: 5, radius: "2px", colour: "#FF9933", dur: 12, delay: 4.2 },
    { left: "53%", w: 6, h: 9, radius: "0", colour: "#138808", dur: 10.5, delay: 1.9 },
    { left: "64%", w: 6, h: 6, radius: "50%", colour: "#FF9933", dur: 13, delay: 3.4 },
    { left: "76%", w: 5, h: 8, radius: "0", colour: "#FFFFFF", dur: 11.5, delay: 5.1, border: "1px solid rgba(31,31,31,.16)" },
    { left: "88%", w: 6, h: 6, radius: "2px", colour: "#138808", dur: 12.5, delay: 2.2 },
];

export default function IndependenceDayHeroCard() {
    return (
        <div className="w4t-id-hero-confetti" aria-hidden="true">
            {CONFETTI.map((c, i) => (
                <span
                    key={i}
                    style={{
                        left: c.left,
                        width: c.w,
                        height: c.h,
                        borderRadius: c.radius,
                        background: c.colour,
                        border: c.border,
                        animationDuration: `${c.dur}s`,
                        animationDelay: `${c.delay}s`,
                    }}
                />
            ))}
        </div>
    );
}
